// import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { FormUi } from '../../Pages/Home/Home';

function FormModal({ show, handleClose }) {
    return (
        <Modal
            show={show}
            backdrop={true}
            dialogClassName="modal-40w"
            onHide={handleClose}
            animation={true}>
            <Modal.Header closeButton>
                {/* <Modal.Title>Modal heading</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
                {/* <div className='p-5'> */}
                    <FormUi />

                {/* </div> */}
            </Modal.Body>
        </Modal>
    );
}

export default FormModal;